import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SeoHead from "@/components/feature/SeoHead";

function BrandSection() {
  return (
    <section id="brand" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6 text-center">
          品牌介绍
        </h2>
        <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed">
          <style>{`
            .prose p { margin-bottom: 1rem; line-height: 1.85; }
          `}</style>
          <p>
            <strong className="text-primary-600">夫妻影院</strong>成立于2024年，是一个专注于为夫妻情侣群体提供电影推荐服务的精品内容平台。我们深知，在忙碌的生活中，夫妻之间能够坐下来一起看一部好电影，是增进感情、放松身心的最佳方式之一。
          </p>
          <p>
            我们的编辑团队由资深影迷和情感关系专家组成，从海量影片中精心筛选最适合夫妻二人共同观看的电影作品。无论是浪漫爱情片、轻松喜剧还是情感剧情片，每一篇推荐都经过团队的反复讨论和精心打磨。
          </p>
          <p>
            夫妻影院不仅提供电影推荐，更致力于为每一对夫妻情侣创造温馨的观影体验。我们关注每一部电影的情感内核、讨论价值和观赏氛围，让每一次观影都成为一次美好的二人世界之旅。
          </p>
          <p>
            截至目前，夫妻影院已累计推荐超过500部优质电影，涵盖了浪漫爱情、轻松喜剧、情感剧情、经典重温等多个分类，服务了超过10万对夫妻情侣用户，获得了广泛的好评和口碑。
          </p>
        </div>
      </div>
    </section>
  );
}

function ReputationSection() {
  const testimonials = [
    {
      name: "李女士",
      role: "已婚5年",
      content: "夫妻影院推荐的电影太适合我们了！以前总为看什么电影吵架，现在每周末跟着推荐看一部，感情越来越好。",
      rating: 5,
    },
    {
      name: "王先生",
      role: "新婚夫妇",
      content: "自从发现了夫妻影院，我们的二人世界变得更加丰富多彩。推荐的电影都很走心，影评写得特别真诚。",
      rating: 5,
    },
    {
      name: "张女士",
      role: "恋爱3年",
      content: "每篇文章都像是一个懂你的朋友在推荐，不仅有剧情介绍还有适合的观影场景，特别贴心。",
      rating: 5,
    },
    {
      name: "陈先生",
      role: "已婚10年",
      content: "结婚十年了，以为没有什么浪漫可言，但夫妻影院推荐的经典重温系列让我们找回了当初的感觉。",
      rating: 5,
    },
    {
      name: "刘女士",
      role: "情侣",
      content: "异地恋的时候跟着推荐一起看同样的电影，看完打电话讨论，感觉距离都变近了。现在同住了依然保持这个习惯。",
      rating: 5,
    },
    {
      name: "赵先生",
      role: "已婚2年",
      content: "分类做得特别好，什么心情都能找到对应的电影。轻松喜剧类是我们最常看的，每次都笑成一团。",
      rating: 5,
    },
  ];

  return (
    <section id="reputation" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3 text-center">
          口碑评价
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-12">
          来自用户的真实反馈
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-secondary-200 p-5 md:p-6"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-xs text-accent-500"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-xs font-medium text-primary-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-950">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [statusMessage, setStatusMessage] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value;
    if (honeypot && honeypot.trim() !== "") {
      setStatus("success");
      setStatusMessage("消息已发送！我们会尽快回复您。");
      return;
    }
    try {
      const formDataObj = new FormData(form);
      const response = await fetch("https://readdy.ai/api/form/d9njda8bdkpk99j7gkn0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formDataObj as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      if (response.ok) {
        setStatus("success");
        setStatusMessage("消息已发送！我们会尽快回复您。");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
        setStatusMessage("发送失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setStatusMessage("网络错误，请稍后重试。");
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3 text-center">
          联系我们
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-8 md:mb-10">
          有任何问题或建议，欢迎随时与我们联系
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mb-10">
          <div className="bg-background-100 rounded-xl p-5 text-center border border-secondary-200">
            <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-mail-line text-lg text-primary-500"></i>
            </div>
            <h3 className="text-sm font-medium text-foreground-950 mb-1">电子邮箱</h3>
            <p className="text-xs text-foreground-600">contact@fuqicinema.com</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center border border-secondary-200">
            <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-wechat-line text-lg text-accent-600"></i>
            </div>
            <h3 className="text-sm font-medium text-foreground-950 mb-1">微信</h3>
            <p className="text-xs text-foreground-600">微信公众号：夫妻影院</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center border border-secondary-200">
            <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-200">
              <i className="ri-map-pin-line text-lg text-secondary-600"></i>
            </div>
            <h3 className="text-sm font-medium text-foreground-950 mb-1">地址</h3>
            <p className="text-xs text-foreground-600">中国 · 北京</p>
          </div>
        </div>

        <form
          ref={formRef}
          onSubmit={handleSubmit}
          className="bg-background-100 rounded-xl border border-secondary-200 p-5 md:p-8"
          data-readdy-form="true"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="spam-field"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                姓名
              </label>
              <input
                type="text"
                id="contact-name"
                name="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="w-full px-4 py-2.5 rounded-lg border border-secondary-300 bg-background-50 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                placeholder="请输入您的姓名"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                邮箱
              </label>
              <input
                type="email"
                id="contact-email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="w-full px-4 py-2.5 rounded-lg border border-secondary-300 bg-background-50 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                placeholder="请输入您的邮箱"
              />
            </div>
          </div>
          <div className="mb-4">
            <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
              留言
            </label>
            <textarea
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              required
              maxLength={500}
              rows={5}
              className="w-full px-4 py-2.5 rounded-lg border border-secondary-300 bg-background-50 text-sm text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
              placeholder="请输入您想说的话（最多500字）"
            />
          </div>
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-primary-500 text-white font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            发送消息
          </button>
          {status === "success" && (
            <p className="mt-4 text-sm text-green-600 text-center">{statusMessage}</p>
          )}
          {status === "error" && (
            <p className="mt-4 text-sm text-red-500 text-center">{statusMessage}</p>
          )}
        </form>
      </div>
    </section>
  );
}

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于夫妻影院",
    description: "夫妻影院品牌介绍、口碑评价和联系方式",
    url: "https://fuqicinema.com/about",
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "夫妻影院",
    url: "https://fuqicinema.com",
    description: "夫妻影院提供适合夫妻情侣共同观看的浪漫电影推荐",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@fuqicinema.com",
      contactType: "customer service",
    },
    address: {
      "@type": "PostalAddress",
      addressLocality: "北京",
      addressCountry: "CN",
    },
  };

  return (
    <>
      <SeoHead
        title="关于我们 - 夫妻影院"
        description="夫妻影院品牌介绍，致力于为夫妻情侣提供精选浪漫电影推荐。了解我们的品牌故事、用户口碑和联系方式。"
        keywords="夫妻影院,关于我们,品牌介绍,口碑评价,联系方式,夫妻电影"
        canonicalUrl="https://fuqicinema.com/about"
        ogType="website"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-secondary-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>

        <section className="py-10 md:py-16 bg-primary-500">
          <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
              关于夫妻影院
            </h1>
            <p className="text-white/80 text-sm md:text-base leading-relaxed">
              夫妻影院是一个专注于为夫妻情侣群体提供电影推荐服务的精品内容平台。
              我们致力于为每一对夫妻情侣打造温馨的二人世界观影体验。
            </p>
          </div>
        </section>

        <BrandSection />
        <ReputationSection />
        <ContactSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}